import { AppHomeDomainCard } from '../AppHomeDomainCard';
import { Container } from './styles';

export default function AppHomeDomainContainer({
  domains,
  isFirstFetch,
  selectedUser,
}) {
  return (
    <Container>
      {domains.map(item => (
        <AppHomeDomainCard
          domain={item.domain}
          estimatedCost={item.estimatedCost}
          drivers={item.drivers}
          ratingAverage={item.ratingAverage}
          isFirstFetch={isFirstFetch}
          logo={item.logo}
          name={item.name}
          selectedUser={selectedUser}
          appTax={item.appTax}
          tripsWaitingDriver={item.tripsWaitingDriver}
        />
      ))}
    </Container>
  );
}
